<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <form id="participant" @submit="checkForm">
                  <!-- I am a card -->
                  <div class="card">
                      <div class="card-header pb-0">
                        <div class="row">
                            <h3 class="mx-auto py-0">I am a</h3>
                        </div>
                      </div>

                      <div class="card-body pb-3">
                         <div class="row">
                           <div class="custom-control custom-radio text-center col">
                             <input type="radio" id="soort1" name="soort" class="custom-control-input" value="freshman" v-model="userdata.soort">
                             <label class="custom-control-label" for="soort1">Freshman</label>
                           </div>
                           <div class="custom-control custom-radio text-center col">
                             <input type="radio" id="soort2" name="soort" class="custom-control-input" value="parent" v-model="userdata.soort">
                             <label class="custom-control-label" for="soort2">Parent</label>
                           </div>
                         </div>
                         <div class="row" v-if="(typeof errors.soort === 'string')">
                           <div class="col text-center">
                              <div class="invalid-feedback">{{ errors.soort }}</div>
                           </div>
                         </div>
                      </div>
                  </div>
                  <!-- end I am a card -->

                  <!-- kiddoData -->
                  <div class="card mt-4" v-show="userdata.soort.length">
                      <div class="card-header pb-0">
                        <div class="row">
                            <h5 class="mx-auto py-0">You are a "{{ userdata.soort | capitalize }}"</h5>
                        </div>
                      </div>

                      <div class="card-body pb-0">
                        <!-- photoNumber -->
                        <div class="form-group row">
                          <label for="photoNumber" class="col-sm-2 col-form-label col-form-label-sm">Photo number</label>
                          <div class="col-sm-10">
                            <input type="number" id="photoNumber" name="photoNumber" class="form-control form-control-sm" v-model.number="userdata.photoNumber" :class="{ 'is-valid': isValid('photoNumber'), 'is-invalid': isInvalid('photoNumber') }" @blur="touchUserdata">
                            <div class="invalid-feedback" v-if="(typeof errors.photoNumber === 'string')">{{ errors.photoNumber }}</div>
                          </div>
                        </div>

                        <!-- groupNumber -->
                        <div class="form-group row">
                          <label for="groupNumber" class="col-sm-2 col-form-label col-form-label-sm">Group number</label>
                          <div class="col-sm-10">
                            <input type="number" id="groupNumber" name="groupNumber" class="form-control form-control-sm" v-model.number="userdata.groupNumber" :class="{ 'is-valid': isValid('groupNumber'), 'is-invalid': isInvalid('groupNumber') }" @blur="touchUserdata">
                            <div class="invalid-feedback" v-if="(typeof errors.groupNumber === 'string')">{{ errors.groupNumber }}</div>
                          </div>
                        </div>


                        <!-- name -->
                        <div class="form-group row mt-5">
                          <label for="name" class="col-sm-2 col-form-label col-form-label-sm">Name</label>
                          <div class="col-sm-10">
                            <input type="text" id="name" name="name" class="form-control form-control-sm" v-model="userdata.name" :class="{ 'is-valid': isValid('name'), 'is-invalid': isInvalid('name') }" @blur="touchUserdata">
                            <div class="invalid-feedback" v-if="(typeof errors.name === 'string')">{{ errors.name }}</div>
                          </div>
                        </div>

                        <!-- age -->
                        <div class="form-group row" v-if="false">
                          <label for="age" class="col-sm-2 col-form-label col-form-label-sm">Age</label>
                          <div class="col-sm-10">
                            <input type="text" id="age" name="age" class="form-control form-control-sm" v-model="userdata.age" :class="{ 'is-valid': isValid('age'), 'is-invalid': isInvalid('age') }" @blur="touchUserdata">
                            <div class="invalid-feedback" v-if="(typeof errors.age === 'string')">{{ errors.age }}</div>
                          </div>
                        </div>

                        <!-- stamstruik -->
                        <div class="form-group row mt-5" v-if="stamstruik">
                          <div class="offset-sm-2 col-sm-10">
                            <div class="custom-control custom-checkbox">
                              <input class="custom-control-input" type="checkbox" id="stamstruik" name="stamstruik" v-model="userdata.stamstruik" true-value="yes" false-value="no">
                              <label class="custom-control-label" for="stamstruik">
                                I give permission to add my info to <a href="https://stamstruik.com" target="_blank">stamstruik.com</a> family tree.
                              </label>
                              <div class="invalid-feedback" v-if="(typeof errors.stamstruik === 'string')">{{ errors.stamstruik }}</div>
                            </div>
                          </div>
                        </div>

                      <!-- poster -->
                      <div class="form-group row">
                        <div class="offset-sm-2 col-sm-10">
                          <div class="custom-control custom-checkbox">
                            <input class="custom-control-input" type="checkbox" id="poster" name="poster" v-model="userdata.poster" true-value="yes" false-value="no">
                            <label class="custom-control-label" for="poster" v-if="userdata.groupNumber">
                              I give permission to add my info to the {{ posterText }}.
                            </label>
                            <label class="custom-control-label" for="poster" v-else>
                              I give permission to add my info to the {{ posterText }}.
                            </label>
                            <div class="invalid-feedback" v-if="(typeof errors.poster === 'string')">{{ errors.poster }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-5">
                        <div class="offset-sm-2">
                          <p class="mx-3"><slot></slot></p>
                        </div>
                      </div>
                      <div class="row mb-4">
                        <div class="offset-sm-2">
                          <button type="submit" class="btn btn-primary mx-3">Submit</button>
                        </div>
                      </div>
                      <div class="alert alert-danger offset-sm-2" role="alert" v-show="(typeof errors.general === 'string')">
                        <h4 class="alert-heading">Oops...</h4>
                        <p class="mb-0">{{ errors.general }}</p>
                      </div>
                    </div>
                  </div>
                  <!-- end kiddoData -->
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            action: {
                type: String,
                required: true,
            },
            stamstruik: {
                type: Boolean,
                default: false,
            },
            posterText: {
                type: String,
                default: 'poster',
            }
        },

        data: () => ({
            userdata: {
              soort: '',
              photoNumber: '',
              groupNumber: '',
              name: '',
              stamstruik_id: '',
              stamstruik: 'no',
              poster: 'no',
            },
            errors: {},
            touchedUserdata: [],
        }),

        methods: {
            validateParticipant(data) {
              data = data || {};

              let errors = {};
              if(typeof data.soort !== 'string' || ! (['freshman', 'parent']).includes(data.soort))
                  errors['soort'] = 'You have to select if you are a freshman or parent.';

              if(typeof data.photoNumber !== 'number' || data.photoNumber <= 0)
                  errors['photoNumber'] = 'Your photo number has to be a positive integer.';

              if(typeof data.groupNumber !== 'number' || data.groupNumber <= 0)
                  errors['groupNumber'] = 'Your group number has to be a positive integer.';

              if(typeof data.name !== 'string' || data.name.length < 2)
                  errors['name'] = 'Your name has to be at least 2 characters.';

              if(this.stamstruik == true && (typeof data.stamstruik !== 'string' || ! (['yes', 'no']).includes(data.stamstruik)))
                  errors['stamstruik'] = 'Please select if you want to be in the stamstruik or not.';

              if(typeof data.poster !== 'string' || ! (['yes', 'no']).includes(data.poster))
                  errors['poster'] = 'Please select if you want to be on the '+ this.posterText +' or not.';

              return errors;
            },

            isValid(name) {
                if(! this.touchedUserdata.includes(name))
                    return false;

                return this.validateOnly(name, true);
            },

            isInvalid(name) {
                if(! this.touchedUserdata.includes(name))
                    return false;

                return ! this.validateOnly(name, true);
            },

            validateOnly(only, always) {
                if(typeof only !== 'string')
                    return false;

                if(typeof always !== 'boolean')
                    always = false;

                if(! always && ! this.touchedUserdata.includes(only))
                    return false;

                let errors = this.validateParticipant(this.userdata);

                if (typeof errors[only] === 'string') {
                    this.errors[only] = errors[only];
                    return false;
                }

                if (typeof this.errors[only] === 'string') {
                    return false;
                }

                return true;
            },

            touchUserdata(e) {
                var name = undefined;
                if(typeof e === 'string')
                  name = e;

                if(typeof e.target.attributes.name.value === 'string')
                  name = e.target.attributes.name.value;


                if(typeof name !== 'undefined' && ! this.touchedUserdata.includes(name))
                    this.touchedUserdata.push(name);
            },

            checkForm(e) {
                e.preventDefault();

                let errors = this.validateParticipant(this.userdata);

                if (this.stamstruik == true) {
                    if(this.userdata.poster !== 'yes' && this.userdata.stamstruik !== 'yes') {
                        errors['general'] = 'You have to at least select to be in the stamstruik or '+this.posterText+'.';
                    }
                } else {
                    if(this.userdata.poster !== 'yes') {
                        errors['general'] = 'If you do not want to appear at the '+this.posterText+', do not submit this form.';
                    }
                }


                this.errors = errors;
                if(Object.keys(errors).length >= 1) {
                    // Make errors visible
                    this.touchedUserdata = Object.keys(this.userdata);
                    return false;
                }

                this.storeParticipant(this.userdata);
            },

            async storeParticipant(data) {
                try {
                  let response = await axios.post(this.action, this.userdata);
                  // Success

                  this.$toasted.success(`Stored ${this.userdata.name}...`);
                  Object.assign(this.$data, this.$options.data.call(this));
                } catch(e) {
                  // Failed
                  console.log(e);
                  console.log(e.response);
                  console.log(e.response.status);

                  let errors = {};
                  if(typeof e.response.status === 'undefined' || e.response.status != 422) {
                    errors['general'] = 'Something went wrong...';

                  } else if(typeof e.response.data.errors === 'object') {
                      for (var error in e.response.data.errors) {
                        let val = e.response.data.errors[error];

                        if(Array.isArray(val)) {
                          errors[error] = val.shift();

                        } else if(typeof val === 'string') {
                          errors[error] = val;

                        } else {
                          errors[error] = val.toString();
                        }

                        if(error == 'stamstruik_id') {
                          errors['general'] = errors['stamstruik_id'];
                          errors[error] = undefined;
                        }
                      }

                  } else {
                      errors['general'] = 'asd';
                  }

                  console.log(errors);
                  this.errors = errors;
                  if(Object.keys(errors).length >= 1) {
                    // Make errors visible
                    this.touchedUserdata = Object.keys(this.userdata);
                    return false;
                  }
                  this.$toasted.error('Failed to store...');
                }
            }
        },

        mounted() {
            //
        }
    }
</script>
